export abstract class Model {
  abstract MAX_NUMBER_OF_CHARACTERS: number;
  abstract TOKENS: number;
}
